module.exports = __webpack_public_path__ + "static/media/Email.a91d905b.svg";